// extracted by mini-css-extract-plugin
export default {"root":"_1X4IZ","expanded":"fbY0U"};